import React from 'react';
import styled from 'styled-components';
import { FaCar, FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube } from 'react-icons/fa';
import Container from './Container';

const FooterWrapper = styled.footer`
  background: ${({ theme }) => theme.colors.darker};
  color: ${({ theme }) => theme.colors.lighter};
  padding: 100px 0 40px;
`;

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 60px;
  margin-bottom: 80px;
`;

const FooterColumn = styled.div``;

const LogoLink = styled.a`
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 26px;
    font-weight: 800;
    margin-bottom: 24px;
    color: ${({ theme }) => theme.colors.lighter};
    text-decoration: none; /* Garante que o logo não tenha sublinhado */
`;

const LogoIcon = styled.div`
    width: 40px;
    height: 40px;
    background: linear-gradient(135deg, ${({ theme }) => theme.colors.primary} 0%, ${({ theme }) => theme.colors.accent} 100%);
    border-radius: ${({ theme }) => theme.radii.sm};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.colors.lighter};
`;

const FooterAbout = styled.p`
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 28px;
    line-height: 1.7;
`;

const SocialLinks = styled.div`
    display: flex;
    gap: 16px;
`;

const SocialLink = styled.a`
    width: 44px;
    height: 44px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.colors.lighter};
    transition: ${({ theme }) => theme.transitions.default};

    &:hover {
        background: ${({ theme }) => theme.colors.primary};
        transform: translateY(-5px);
    }
`;

const FooterTitle = styled.h3`
  font-size: 20px;
  font-weight: 800;
  margin-bottom: 28px;
`;

const FooterLinks = styled.ul`
  list-style: none;
  padding: 0;
  li {
    margin-bottom: 16px;
  }
  a {
    color: rgba(255, 255, 255, 0.7);
    transition: all 0.2s ease;
    text-decoration: none; /* ✅ CORREÇÃO: Remove o sublinhado dos links */

    &:hover {
      color: ${({ theme }) => theme.colors.lighter};
      transform: translateX(5px);
      display: inline-block;
    }
  }
`;

const FooterBottom = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.5);

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
      flex-direction: column;
      gap: 20px;
      text-align: center;
  }
`;

const Footer = () => {
  return (
    <FooterWrapper>
      <Container>
        <FooterGrid>
          <FooterColumn>
            <LogoLink href="/">
                <LogoIcon><FaCar /></LogoIcon>
                <span>Consulta Veículos</span>
            </LogoLink>
            <FooterAbout>O serviço mais completo e confiável para consulta de veículos por placa no Brasil.</FooterAbout>
            <SocialLinks>
                <SocialLink href="#"><FaFacebookF /></SocialLink>
                <SocialLink href="#"><FaInstagram /></SocialLink>
                <SocialLink href="#"><FaLinkedinIn /></SocialLink>
                <SocialLink href="#"><FaYoutube /></SocialLink>
            </SocialLinks>
          </FooterColumn>
          <FooterColumn>
            <FooterTitle>Serviços</FooterTitle>
            <FooterLinks>
              <li><a href="#">Consulta Completa</a></li>
              <li><a href="#">BIN Federal</a></li>
              <li><a href="#">Decodificador de Chassi</a></li>
              <li><a href="#">Histórico de Leilão</a></li>
            </FooterLinks>
          </FooterColumn>
          <FooterColumn>
            <FooterTitle>Empresa</FooterTitle>
            <FooterLinks>
              <li><a href="#">Sobre Nós</a></li>
              <li><a href="#">Termos de Uso</a></li>
              <li><a href="#">Política de Privacidade</a></li>
              <li><a href="#">Trabalhe Conosco</a></li>
            </FooterLinks>
          </FooterColumn>
          <FooterColumn>
            <FooterTitle>Ajuda</FooterTitle>
            <FooterLinks>
              <li><a href="#">Central de Ajuda</a></li>
              <li><a href="#">Perguntas Frequentes</a></li>
              <li><a href="#">Contato</a></li>
            </FooterLinks>
          </FooterColumn>
        </FooterGrid>
        <FooterBottom>
          <p>© {new Date().getFullYear()} Consulta Veículos. Todos os direitos reservados.</p>
        </FooterBottom>
      </Container>
    </FooterWrapper>
  );
};

export default Footer;